import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CustomerReviewModel } from '../../models/billing/customer-review.model';
import { ShipmentReviewModel } from '../../models/billing/shipment-review.model';
import { map } from 'rxjs/operators';
import { ShipmentInternalReviewModel } from '../../models/settlement/shipment-internal-review.model';

@Injectable({
  providedIn: 'root',
})
export class BillingService {
  constructor(private apiService: ApiService) {}

  getCustomersReview(): Observable<CustomerReviewModel[]> {
    return this.apiService.get<CustomerReviewModel[]>(
      environment.hairballBilling.customerReview
    );
  }

  updateCustomerReview(customerReview: any): Observable<any> {
    return this.apiService.put(
      environment.hairballBilling.updateCustomerReview,
      customerReview
    );
  }

  insertShipmentReview(data: any): Observable<any> {
    return this.apiService.post(
      environment.hairballBilling.insertShipmentReview,
      data
    );
  }

  getShipmentReview(
    shipmentId: number,
    reviewType: string
  ): Observable<ShipmentReviewModel[]> {
    return this.apiService
      .get<ShipmentReviewModel[]>(
        `${environment.hairballBilling.getShipmentReviews}/${shipmentId}/${reviewType}`
      )
      .pipe(
        map((response) => (response ?? []))
      );
  }

  createManualBenchmarkPricesheet(data: any): Observable<any> {
    return this.apiService.post(
      environment.hairballBilling.createManualBenchmarkPricesheet,
      data
    );
  }

  createManualPreProgramPricesheet(data: any): Observable<any> {
    return this.apiService.post(
      environment.hairballBilling.createManualPreProgramPricesheet,
      data
    );
  }

  createMassComment(data: ShipmentInternalReviewModel): Observable<any> {
    return this.apiService.post(
      environment.hairballBilling.createMassComment,
      data
    );
  }

  releaseFromInternalReview(
    data: ShipmentInternalReviewModel
  ): Observable<any> {
    return this.apiService.post(
      environment.hairballBilling.internalReviewRelease,
      data
    );
  }

  uploadPricesheetFile(data: FormData): Observable<any> {
    return this.apiService.post<any>(
      environment.hairballBilling.uploadPricesheetFile,
      data
    );
  }

  exportInternalReviewData(data: any): Observable<any> {
    return this.apiService.downloadFileCSVPOST(
      environment.hairballBilling.exportInternalReviewData,
      data
    );
  }
}